const HOST = import.meta.env.VITE_API_HOST;

/**
 * Fetch the public order summary used by the order landing page. The QR only
 * carries the order id, so the rest of the fields are loaded from here.
 * @async
 * @param {string} orderId
 * @returns {Promise<{id: string, status: number, minutesAmount: number, priceRub: number, paymentUrl: string, phoneNumber: string}>}
 */
export async function getOnlineOrder(orderId) {
  const resp = await fetch(`${HOST}/api/v1/customer/online-order/${orderId}`);
  if (resp.status != 200) {
    const body = await resp.text();
    throw new Error(body);
  }
  return resp.json();
}

/**
 * @async
 * @param {string} orderId
 */
export async function sendOnlineOrderOpened(orderId) {
  const resp = await fetch(
    `${HOST}/api/v1/customer/online-order/opened/${orderId}`,
  );
  if (resp.status != 200) {
    const body = await resp.text();
    // Try to parse JSON error body
    let parsed;
    try {
      parsed = JSON.parse(body);
    } catch {
      throw new Error(body);
    }
    const err = new Error(parsed.message || body);
    err.current_status = parsed.current_status;
    throw err;
  }
}

/**
 * @async
 * @param {string} orderId
 */
export async function sendOnlineOrderPaymentStarted(orderId) {
  const resp = await fetch(
    `${HOST}/api/v1/customer/online-order/payment-started/${orderId}`,
  );
  if (resp.status != 200) {
    const body = await resp.text();
    // Try to parse JSON error body
    let parsed;
    try {
      parsed = JSON.parse(body);
    } catch {
      throw new Error(body);
    }
    const err = new Error(parsed.message || body);
    err.current_status = parsed.current_status;
    throw err;
  }
}
